module.exports = __webpack_public_path__ + "media/xoi-the-sea.f86b20c4.mp3";